import { useAuth } from '@frontegg/react';
import { useIsOP } from 'src/hooks/misc/useTenant';

export const OP_EHR_SYNC_DISABLED_ROLE_KEY = 'op-practice-provider-part-time';

export const useIsOpEhrSyncDisabled = (): boolean => {
  const { user } = useAuth();
  const isOP = useIsOP();
  const hasOpDisabledRole = Boolean(
    user?.roles?.some((role) => role.key === OP_EHR_SYNC_DISABLED_ROLE_KEY)
  );
  return isOP && hasOpDisabledRole;
};
